<div>By {{user?.name[0].value}} on {{date | date:'medium'}}</div>
